import noUiSlider from 'nouislider';
import MicroModal from 'micromodal';
import $ from 'jquery';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';

if (document.body.classList.contains('page-template-apartments') || document.body.classList.contains('tax-floor')) {
    const tableWrapper = document.querySelector('.apartments-table-wrapper');
    const tableFilters = document.querySelector('.apartments-table-filters');
    const roomsSelect = $('#roomsSelect');
    const floorSelect = $('#floorSelect');
    const reservedCheck = $('#reservedCheck');
    const sizeMin = $('#sizeMin');
    const sizeMax = $('#sizeMax');
    const clearFilters = $('#clearFilters');
    const storeys = document.querySelectorAll('.apartment-mockup__storeys g.st0');
    let langCode = '-pl';

    if (document.documentElement.lang == 'en-GB') {
        langCode = '-en';
    }

    $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
        let min = parseInt(sizeMin.text());
        let max = parseInt(sizeMax.text());

        const size = parseFloat(data[1]) || 0;
        if (
            (isNaN(min) && isNaN(max)) ||
            (isNaN(min) && size <= max) ||
            (min <= size && isNaN(max)) ||
            (min <= size && size <= max)
        ) {
            return true;
        }
        return false;
    });

    const table = $('#apartmentsTable').DataTable({
        paging: false,
        info: false,
        columns: [
            { 'type': 'num' },
            null,
            null,
            null,
            null,
            { orderable: false },
            { orderable: false },
            { orderable: false }
        ],
        'language': {
            'zeroRecords': site_data.no_found
        }
    });

    roomsSelect.on('change', function () {
        table.column(2).search(this.value).draw();
    });

    floorSelect.on('change', function () {
        table.column(4).search(this.value).draw();
    });

    reservedCheck.on('change', function () {
        if (this.checked) {
            table.column(6).search(`${site_data.available_string}`).draw();
        } else {
            table.column(6).search('').draw();
        }
    });

    // Display available flats
    table.column(6).search(`${site_data.available_string}`).draw();

    const minRange = parseInt(sizeMin.text());
    const maxRange = parseInt(sizeMax.text());
    const slider = document.getElementById('trslider');
    noUiSlider.create(slider, {
        start: [minRange, maxRange],
        connect: true,
        step: 1,
        format: {
            to: function (value) {
                return Math.round(value);
            },
            from: function (value) {
                return Number(value);
            }
        },
        range: {
            'min': minRange,
            'max': maxRange
        }
    });

    slider.noUiSlider.on('update', function (event) {
        sizeMin.text(event[0]);
        sizeMax.text(event[1]);
        table.draw();
    });

    clearFilters.on('click', function (e) {
        e.preventDefault();
        tableFilters.reset();
        // sizeMin.text(minRange);
        // sizeMax.text(maxRange);
        slider.noUiSlider.set([minRange, maxRange]);
        table.columns('').search('').draw();
    });

    [...storeys].forEach((el, index) => {
        el.addEventListener('click', (e) => {
            let floor = el.getAttribute('data-table-floor');
            window.location.href = window.location.origin + '/floor/' + floor + langCode;

            // [...storeys].forEach(storey => storey.classList.remove('is-active'));
            // el.classList.add('is-active');

            // table.column(4).search(el.getAttribute('data-table-floor')).draw();

            // $('html, body').animate({
            //     scrollTop: $(tableWrapper).offset().top - 100
            // }, 100);           
        })
    });

    // Show/hide mobile more options panel
    const apartmentMobileDropdownTriggers = document.querySelectorAll('.apartment-table-mobile-dropdown-trigger');
    apartmentMobileDropdownTriggers.forEach(trigger => {

        tableWrapper.addEventListener('click', (e) => {
            // e.preventDefault();
            const isClickInside = trigger.contains(e.target);

            if (!isClickInside) {
                trigger.nextElementSibling.classList.remove('is-open');
                if (e.target.classList.contains('apartment-table-mobile-dropdown')) {
                    let pdfPlanUrl = e.target.getAttribute('data-plan-url');

                    if (pdfPlanUrl != '') {
                        window.open(pdfPlanUrl, '_blank');
                    }
                }

            } else {
                trigger.nextElementSibling.classList.toggle('is-open');
            }
        });
    });
}

if (document.body.classList.contains('page-template-apartments') || document.body.classList.contains('single-apartment') || document.body.classList.contains('tax-floor') || document.querySelector('.lokal')) {
    //Show/hide modal with form when click "Wyślij zapytanie" button
    const modalContactTriggers = document.querySelectorAll('.modal-contact-trigger');
    if (!!modalContactTriggers.length) {
        let modalApartmentName = document.getElementById('modalApartmentName');
        let apartmentNameField = document.getElementById('apartmentNameField');
        const wpcf7Form = document.querySelector('.wpcf7-form');

        modalContactTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const apartmentName = trigger.getAttribute('data-apartment-name');
                modalApartmentName.textContent = apartmentName;
                apartmentNameField.value = apartmentName;

                MicroModal.show('modalContactForm', {
                    disableScroll: true,
                    onShow: modal => {
                        modal.scrollTo(0, 0);
                        $('input').trigger('blur');
                    },
                    onClose: modal => {
                        wpcf7Form.reset();
                        modal.scrollTo(0, 0);
                    }
                });
            });
        });
    }
}

if (document.body.classList.contains('tax-floor') || document.querySelector('.commercialPremisesMocup')) {

    tippy('.flat-object', {
        content(reference) {
            const id = reference.getAttribute('data-template');
            const template = document.getElementById(id);
            return template.innerHTML;
        },
        allowHTML: true,
        theme: 'light-border',
        interactive: true,
        appendTo: document.body,
    });
}
